import {useEffect} from 'react'
import {Outlet, useLocation} from 'react-router-dom'
import {HeaderWrapper} from './components/header'
import {RightToolbar} from '../partials/layout/RightToolbar'
import {ScrollTop} from './components/scroll-top'
import {Content} from './components/content'
import {Sidebar} from './components/sidebar'
import {
  DrawerMessenger,
  ActivityDrawer,
  InviteUsers,
  UpgradePlan,
  ThemeModeProvider,
} from '../partials'
import {PageDataProvider} from './core'
import {reInitMenu} from '../helpers'
import {ToolbarWrapper} from './components/toolbar'
import { TrialBanner, useTrialBannerVisible, TRIAL_BANNER_HEIGHT } from '../partials/layout/TrialBanner'
import { ImpersonationBanner } from '../partials/layout/ImpersonationBanner'
import {EmailVerificationNotice} from '../partials/layout/EmailVerificationNotice'
import {RushMind} from '../partials/widgets/rushmind'
import {useAuth} from '../../app/modules/auth'

const MasterLayout = () => {
  const location = useLocation()
  const {currentUser} = useAuth()
  useEffect(() => {
    reInitMenu()
  }, [location.key])

  const { visible, height } = useTrialBannerVisible()

  return (
    <PageDataProvider>
      <ThemeModeProvider>
        <ImpersonationBanner />
        <div className='d-flex flex-column flex-root app-root' id='kt_app_root'>
          <div className='app-page flex-column flex-column-fluid' id='kt_app_page'>
            {visible && <TrialBanner />}
            <div style={visible ? {marginTop: height} : undefined}>
              <HeaderWrapper />
            </div>
            <div className='app-wrapper flex-column flex-row-fluid' id='kt_app_wrapper'>
              <Sidebar />
              <div className='app-main flex-column flex-row-fluid' id='kt_app_main'>
                <div className='d-flex flex-column flex-column-fluid'>
                  <EmailVerificationNotice />
                  <ToolbarWrapper />
                  <Content>
                    <Outlet />
                  </Content>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* begin:: Drawers */}
        <ActivityDrawer />
        <RightToolbar />
        <DrawerMessenger />
        {/* end:: Drawers */}

        {/* begin:: Modals */}
        <InviteUsers />
        {/* end:: Modals */}
        
        {/* begin:: RushMind Widget */}
        {!currentUser?.external_user && <RushMind />}
        {/* end:: RushMind Widget */}
        
        <ScrollTop />
      </ThemeModeProvider>
    </PageDataProvider>
  )
}

export {MasterLayout}
